module.exports = __webpack_public_path__ + "media/flares.01c1427d.mp4";